




import { Vue, Component } from 'vue-property-decorator';
import { orderListTypes, focusTabName } from '@/const/order';
import ContentBottom from '@/components/shipping/order/ContentBottom.vue';

@Component({
  components: {
    ContentBottom,
  },
})
export default class OrderHoldDelivery extends Vue {
  private orderListTypes = orderListTypes.HOLD_DELIVERY;
  private orderSearchTypes = focusTabName.ORDER_TAB;
}
